import { ResultSet } from "../../../../../../API/fields";

export function hasDisplacedCalibration(
  resultSets: ResultSet[],
  selectedResultSet: ResultSet | undefined,
): boolean {
  const drivingDayId = selectedResultSet?.driving_day_id;
  const selectedIsUncalibrated = selectedResultSet?.calibration == null;

  return Boolean(
    drivingDayId &&
      selectedIsUncalibrated &&
      resultSets.some(
        (resultSet) =>
          resultSet.calibration != null &&
          resultSet.driving_day_id === drivingDayId,
      ),
  );
}
